/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

import { VscFileSubmodule } from "react-icons/vsc";
import { GrAttraction, GrRestaurant } from "react-icons/gr";
import {
  MdMusicNote,
  MdOutlineMuseum,
  MdOutlineFoodBank,
  MdOutlineNightlight,
  MdOutlineHotelClass,
  MdOutlineFormatPaint,
  MdOutlineMapsHomeWork,
  MdShop,
} from "react-icons/md";
import { SiHotelsdotcom } from "react-icons/si";
import { AiOutlineShopping } from "react-icons/ai";
import { BiCameraMovie } from "react-icons/bi";
import { GiTheater, GiBallerinaShoes } from "react-icons/gi";
import { HiOutlineDocument } from "react-icons/hi";

import { Card, GoBack, DashboardIntro } from "../../../component/Component";
import {
  pushLevel,
  getSingleLevelDashboard,
} from "../../../../../middlewares/sysNavigation/SysNavigation";
import { addOneLevel } from "../../../../../middlewares/breadCrumb/BreadCrumb";
import { useAdminContext } from "../../../../../context/admin/context/AdminContext";
import { getType } from "../../contentStats/helper";
import { _TYPES_ } from "../../../../doseeData/utils/types";
import { useDashboardLevelContext } from "../../../../../context/levels/levelsContext";

const levelsRoute = "/levels";

const ICONS = {
  "events": <VscFileSubmodule />,
  "attractions": <GrAttraction />,
  "restaurants": <GrRestaurant />,
  "best of africa": <MdOutlineHotelClass />,
  "music": <MdMusicNote />,
  "news": <HiOutlineDocument />,
  "safaris": <MdOutlineMuseum />,
  "tour packages": <GrAttraction />,
  "cinema": <BiCameraMovie />,
  "museums": <MdOutlineMuseum />,
  "night life": <MdOutlineNightlight />,
  "hotels": <SiHotelsdotcom />,
  "classes": <MdOutlineHotelClass />,
  "shopping": <AiOutlineShopping />,
  "food": <MdOutlineFoodBank />,
  "books": <HiOutlineDocument />,
  "neighborhoods": <MdOutlineMapsHomeWork />,
  "arts": <MdOutlineFormatPaint />,
  "dance": <GiBallerinaShoes />,
  "theaters": <GiTheater />,
  "city guides": <MdOutlineMapsHomeWork />,
  "parties": <HiOutlineDocument />,
  "things to do": <HiOutlineDocument />,
  "tips and advice": <HiOutlineDocument />,
  "ministries": <MdOutlineMapsHomeWork />,
  "movies": <GiTheater />,
  "getting around": <MdOutlineMapsHomeWork />,
  "products": <MdShop />,
};

const DashboardLevel = () => {
  const { sysAdmin, setSingleAdmin } = useAdminContext();
  const { data, level } = getSingleLevelDashboard();
  const { statsLevel, fetchLevelData } = useDashboardLevelContext();

  const [query, setQuery] = useState("");

  const levelName = data?.name;
  const lvl = level || "First";

  // Determine level_id based on level label 
  let level_id = null;
  if (lvl === "First") level_id = data?.first_level_id;
  else if (lvl === "Second") level_id = data?.second_level_id;
  else if (lvl === "Third") level_id = data?.third_level_id;
  else if (lvl === "Fourth") level_id = data?.fourth_level_id;

  useEffect(() => {
    fetchLevelData(level_id, lvl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [level_id, lvl]);

  // Source list (unchanged fields/keys)
  const List = useMemo(
    () => [
      { name: "events", quantity: statsLevel ? statsLevel?.event : "-", route: "/data/event", key: _TYPES_.EVENT },
      { name: "attractions", quantity: statsLevel ? statsLevel?.attraction : "-", route: "/data/attraction", key: _TYPES_.ATTRACTION },
      { name: "restaurants", quantity: statsLevel ? statsLevel?.restaurant : "-", route: "/data/restaurant", key: _TYPES_.RESTAURANT },
      { name: "best of africa", quantity: statsLevel ? statsLevel?.best_of_africa : "-", route: "/data/bestofafrica", key: _TYPES_.BESTOFAFRICA },
      { name: "music", quantity: statsLevel ? statsLevel?.music : "-", route: "/data/music", key: _TYPES_.MUSIC },
      { name: "news", quantity: statsLevel ? statsLevel?.news : "-", route: "/data/news", key: _TYPES_.NEWS },
      { name: "safaris", quantity: statsLevel ? statsLevel?.safari : "-", route: "/data/safari", key: _TYPES_.SAFARI },
      { name: "tour packages", quantity: statsLevel ? statsLevel?.tour_package : "-", route: "/data/tour/package", key: _TYPES_.TOURPACKAGE },
      { name: "cinema", quantity: statsLevel ? statsLevel?.cinema : "-", route: "/data/cinema", key: _TYPES_.CINEMA },
      { name: "museums", quantity: statsLevel ? statsLevel?.museum : "-", route: "/data/museum", key: _TYPES_.MUSEUM },
      { name: "night life", quantity: statsLevel ? statsLevel?.nightlife : "-", route: "/data/nightlife", key: _TYPES_.NIGHTLIFE },
      { name: "hotels", quantity: statsLevel ? statsLevel?.hotel : "-", route: "/data/hotel", key: _TYPES_.HOTEL },
      { name: "classes", quantity: statsLevel ? statsLevel?.class : "-", route: "/data/class", key: _TYPES_.CLASSES },
      { name: "shopping", quantity: statsLevel ? statsLevel?.shopping : "-", route: "/data/shopping", key: _TYPES_.SHOPPING },
      { name: "food", quantity: statsLevel ? statsLevel?.food : "-", route: "/data/food", key: _TYPES_.FOOD },
      { name: "books", quantity: statsLevel ? statsLevel?.book : "-", route: "/data/book", key: _TYPES_.BOOK },
      { name: "neighborhoods", quantity: statsLevel ? statsLevel?.neighborhood : "-", route: "/data/neighborhood", key: _TYPES_.NEIGHBORHOOD },
      { name: "arts", quantity: statsLevel ? statsLevel?.art : "-", route: "/data/art", key: _TYPES_.ART },
      { name: "dance", quantity: statsLevel ? statsLevel?.dance : "-", route: "/data/dance", key: _TYPES_.DANCE },
      { name: "theaters", quantity: statsLevel ? statsLevel?.theater : "-", route: "/data/theater", key: _TYPES_.THEATER },
      { name: "City Guides", quantity: statsLevel ? statsLevel?.city_guide : "-", route: "/data/city/guide", key: _TYPES_.CITYGUIDE },
      { name: "Parties", quantity: statsLevel ? statsLevel?.party : "-", route: "/data/party", key: _TYPES_.PARTY },
      { name: "Things To Do", quantity: statsLevel ? statsLevel?.things_to_do : "-", route: "/data/things/todo", key: _TYPES_.THINGSTODO },
      { name: "Tips And Advice", quantity: statsLevel ? statsLevel?.tips_and_advice : "-", route: "/data/tips/advice", key: _TYPES_.TIPSANDADVICE },
      { name: "Ministries", quantity: statsLevel ? statsLevel?.ministry : "-", route: "/data/ministry", key: _TYPES_.MINISTRY },
      { name: "Movies", quantity: statsLevel ? statsLevel?.movie : "-", route: "/data/movie", key: _TYPES_.MOVIE },
      { name: "Getting Around", quantity: statsLevel ? statsLevel?.getting_around : "-", route: "/data/get/around", key: _TYPES_.GETTINGAROUND },
      { name: "Products", quantity: statsLevel ? statsLevel?.product : "-", route: "/data/product", key: _TYPES_.PRODUCT },
    ],
    [statsLevel]
  );

  // Search filter (UI-only)
  const filtered = useMemo(() => {
    if (!query) return List;
    const q = query.toLowerCase();
    return List.filter((c) => String(c.name).toLowerCase().includes(q));
  }, [List, query]);

  // Simple totals for the header
  const totalItems = useMemo(() => {
    if (!statsLevel) return "—";
    try {
      return List.reduce((sum, i) => {
        const n = Number(i.quantity);
        return sum + (isNaN(n) ? 0 : n);
      }, 0);
    } catch {
      return "—";
    }
  }, [statsLevel, List]);

  return (
    <div className="overflow-y-auto p-3 lg:p-4 h-full rounded-b-xl bg-gray-50 pb-5">
      <GoBack props={{ route: `${levelsRoute}/${(lvl || "first")?.toString().toLowerCase()}` }} />

      <div className="mx-auto max-w-7xl">
        {/* Header / Intro */}
        <div className="mt-2 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="flex-1">
              <DashboardIntro props={{ intro: `${lvl} Level`, name: levelName }} />
              <p className="mt-1 text-[11px] text-gray-600">
                Manage content types for this level. Use the search to quickly locate a card.
              </p>
            </div>

            <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
              {/* Tiny summary */}
              <div className="grid grid-cols-3 gap-2">
                <StatPill label="Level" value={lvl} />
                <StatPill label="ID" value={level_id ?? "—"} />
                <StatPill label="Total Items" value={totalItems} />
              </div>

              {/* Search */}
              <div className="relative">
                <input
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Search content (e.g., hotels, news)"
                  className="w-full sm:w-64 rounded-lg border border-gray-200 bg-white p-2.5 pr-8 text-xs focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200"
                />
                {query ? (
                  <button
                    type="button"
                    aria-label="Clear"
                    onClick={() => setQuery("")}
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    ×
                  </button>
                ) : null}
              </div>
            </div>
          </div>

          {/* Accent line */}
          <div className="mt-4 h-[3px] w-full bg-gradient-to-r from-emerald-500 via-amber-500 to-purple-500/70 opacity-20" />
        </div>

        {/* Cards */}
        <div className="mt-4 grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-4 items-stretch selection:text-white selection:bg-blue-900">
          {!statsLevel ? (
            // Lightweight skeletons while loading
            Array.from({ length: 8 }).map((_, i) => (
              <div
                key={i}
                className="h-[96px] rounded-xl border border-gray-200 bg-gray-50 animate-pulse"
              />
            ))
          ) : filtered.length === 0 ? (
            <div className="col-span-full">
              <div className="rounded-xl border border-dashed border-gray-200 bg-white p-8 text-center text-xs text-gray-600 shadow-sm">
                No matches found. Try a different keyword.
              </div>
            </div>
          ) : (
            filtered.map((card, index) => {
              const icon =
                ICONS[String(card.name).toLowerCase()] || <MdOutlineMapsHomeWork />;

              return (
                <Link
                  to={card?.route}
                  key={`${card?.name}-${index}`}
                  onClick={() => {
                    if (
                      ![
                        "regions",
                        "countries",
                        "First Level",
                        "Second Level",
                        "Third Level",
                        "Fourth Level",
                      ].includes(card.name)
                    ) {
                      setSingleAdmin({
                        ids: [sysAdmin?.admin_id],
                        type: getType({ field: card?.key }),
                        route: "/level/dashboard",
                      });
                      addOneLevel({
                        id: 0,
                        name: `${sysAdmin?.first_name} ${sysAdmin?.last_name}`,
                        route: "/levels/first",
                        level: "",
                        country_id: 0,
                        data: {
                          data: {
                            name: "",
                            country_id: 0,
                            first_level_id: 0,
                            second_level_id: 0,
                            third_level_id: 0,
                            fourth_level_id: 0,
                            level: "",
                          },
                        },
                      });
                      pushLevel({
                        level: {
                          id: 0,
                          name: "",
                          level: "All",
                          route: "/levels/first",
                          data: null,
                        },
                      });
                    }
                  }}
                >
                  {/* Gentle hover lift */}
                  <div className="transition-transform duration-150 ease-out hover:-translate-y-0.5">
                    <Card
                      card={{
                        name: card.name,
                        quantity: card.quantity,
                        icon,
                      }}
                    />
                  </div>
                </Link>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardLevel;

/* ---------- Small helper: compact stat pill ---------- */
const StatPill = ({ label, value }) => (
  <div className="rounded-xl border border-gray-100 bg-gray-50 px-3 py-2 text-center">
    <p className="text-[10px] font-medium text-gray-600">{label}</p>
    <p className="text-sm font-semibold text-gray-900 truncate">{String(value ?? "—")}</p>
  </div>
);
